module.exports = __webpack_public_path__ + "videos/3d-export_jp.84c677a.webm";